// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ff450";
export var icon = "footer-module--icon--cb029";
export var links = "footer-module--links--c1916";
export var phoneAlias = "footer-module--phoneAlias--9ae5d";
export var social = "footer-module--social--d8e77";